import src from "IMAGE";
export default { src, width: 76, height: 71, blurWidth: 0, blurHeight: 0};
